// mapsUrl.ts — Google-Maps-Suchlink für eine Anschrift (Kontaktliste, Anlage, Akte).

export type MapsAnschrift = { strasse?: string; plz?: string; ort?: string; land?: string };

/**
 * Google-Maps-Suchlink für eine Anschrift (Straße, PLZ Ort, Land).
 *
 * Das Land gehört zwingend dazu: Ohne es sucht Google im Umkreis des Nutzers
 * und landet bei einer Amsterdamer Adresse plausibel in Deutschland. Fehlt es —
 * im Bestand der Normalfall —, ist die erzeugte Adresse zeichengleich zu vorher.
 */
export function mapsUrl(parts: MapsAnschrift): string {
  const q = [parts.strasse?.trim(), parts.plz?.trim(), parts.ort?.trim(), parts.land?.trim()]
    .filter(Boolean)
    .join(" ");
  return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(q);
}

/** Gibt es etwas zu suchen? Straße, PLZ oder Ort — das Land allein reicht nicht. */
export const hatAnschrift = (parts: MapsAnschrift): boolean =>
  !!(parts.strasse?.trim() || parts.plz?.trim() || parts.ort?.trim());
